export function toTitleCase(inputString: string) {
  // Split the input string into words using regular expression
  // This regex splits on spaces, hyphens, and underscores
  const words = inputString.split(/[ \-_]+/)

  // Create an array to store the capitalized words
  const titleCaseWords: string[] = []

  // Iterate through the words and capitalize the first letter of each word
  for (const word of words) {
    if (word.length > 0) {
      // Capitalize the first letter and convert the rest of the word to lowercase
      const titleCaseWord = word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
      titleCaseWords.push(titleCaseWord)
    }
  }

  // Join the title case words back together with spaces
  const titleCaseString = titleCaseWords.join(' ')

  return titleCaseString
}
